import { ThemeDefinition } from 'vuetify/framework';

export const STATUS_ROLE_MAP: Record<string, string> = {
    // Order statuses
    pending: 'info',
    ready: 'primary',
    fulfilled: 'success',
    cancelled: 'error',
    scheduled: 'secondary',

    // Payment statuses
    unpaid: 'warning',
    paid: 'success',
    partial: 'info',
    overdue: 'error',
};

export const addStatusColors = (theme: ThemeDefinition): ThemeDefinition => {
    const baseColors = theme.colors ?? {};
    const statusColors: Record<string, string> = {};

    Object.entries(STATUS_ROLE_MAP).forEach(([status, role]) => {
        const roleColor = baseColors[role];
        if (roleColor) {
            statusColors[`status-${status}`] = roleColor;
        }
    });

    return {
        ...theme,
        colors: {
            ...baseColors,
            ...statusColors,
        },
    };
};
